export default function ({ app, store, redirect }) {
    const paymentMethod = store.getters['cart/getPaymentMethod']

    if (!paymentMethod) {
        return redirect(app.$locale.path('checkout'))
    }
}
